export default ['SOCIAL_MEDIA', 'SOCIAL_MEDIA_PUBLIC_REVIEWS_ONLY'];
